module.exports = __webpack_public_path__ + "img/share1.40d68de5.png";